// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resizable {
    width: 200px;
    height: 200px;
    border: 1px solid #ccc;
    resize: both;
    overflow: hidden;
    position: relative;
    cursor: pointer;
}

.resizer {
    width: 20px;
    height: 20px;
    z-index: 200;
    background-color: transparent;
    position: absolute;
    right: -5px;
    bottom: -5px;
    /* margin-right: -5px; */
    cursor: se-resize;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;AACrB","sourcesContent":[".resizable {\n    width: 200px;\n    height: 200px;\n    border: 1px solid #ccc;\n    resize: both;\n    overflow: hidden;\n    position: relative;\n    cursor: pointer;\n}\n\n.resizer {\n    width: 20px;\n    height: 20px;\n    z-index: 200;\n    background-color: transparent;\n    position: absolute;\n    right: -5px;\n    bottom: -5px;\n    /* margin-right: -5px; */\n    cursor: se-resize;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
